/**
 * MEMBER TIME FORMAT — presentation only.
 * =======================================
 *
 * One member preference, 12-hour or 24-hour, read from one place. It decides how a time is
 * WRITTEN and nothing else: no timezone maths, no parsing, no date arithmetic, no chronology, no
 * locale substitution. Each surface keeps its own wording and its own locale; all this does is
 * settle `hour12` for it.
 *
 * The account is the authority (`time_format` on the member's record). This mirror is what the
 * screens read, so a time never renders in a format the member did not choose. Absent means
 * 12-hour.
 */

export const TIME_FORMAT_KEY = 'arvexis_time_format';
export const TWELVE_HOUR = '12h';
export const TWENTY_FOUR_HOUR = '24h';

export const normaliseTimeFormat = (value) =>
  value === TWENTY_FOUR_HOUR ? TWENTY_FOUR_HOUR : TWELVE_HOUR;

export const getMemberTimeFormat = () => {
  try {
    return normaliseTimeFormat(localStorage.getItem(TIME_FORMAT_KEY));
  } catch {
    return TWELVE_HOUR;
  }
};

export const storeMemberTimeFormat = (value) => {
  const next = normaliseTimeFormat(value);
  try {
    localStorage.setItem(TIME_FORMAT_KEY, next);
  } catch {
    /* a device that refuses storage still gets the default, never a wrong format */
  }
  return next;
};

export const isTwentyFourHour = () => getMemberTimeFormat() === TWENTY_FOUR_HOUR;

/**
 * Add the member's choice to a surface's own `toLocaleTimeString` / `toLocaleDateString` options.
 * Everything the caller already asked for is preserved exactly.
 */
export const memberTimeOptions = (options = {}) => ({ ...options, hour12: !isTwentyFourHour() });
